export default {"src":"/_next/static/media/skill_training_center.0e020b3e.svg","height":284,"width":284};